export const theme = {
  primary: "#daa520",
};
